import Link from 'next/link'

import styled from 'styled-components'
import { flexDirection, FlexDirectionProps } from 'styled-system'
import { themeGet } from '@styled-system/theme-get'

import { DIV_SHOULD_FORWARD_PROP } from 'Config/shouldForwardProp'

import { gap, GapProps } from 'Services/Styles'

const shouldForwardProp = (prop: string | number) => {
  return !DIV_SHOULD_FORWARD_PROP.includes(String(prop))
}

export const Container = styled.div.withConfig({
  shouldForwardProp,
})<FlexDirectionProps & GapProps>`
  display: flex;

  ${flexDirection}
  ${gap}
`

export const StyledLink = styled(Link)`
  height: 28px;
  text-decoration: none;

  > span {
    color: ${themeGet('colors.text.invertedTitle')};

    &:hover {
      color: ${themeGet('colors.text.invertedMuted')};
    }
  }
`
